module.exports = __webpack_public_path__ + "img/map.1d49a517.png";